// extracted by mini-css-extract-plugin
var _1 = "DPz3kVQQF8rvQ_B2GIfw";
export { _1 as "sp3Logo" }
